module.exports = __webpack_public_path__ + "img/shape-1.6802cab1.svg";